import * as Types from '../actions';

export interface CallReducer {
  muteAudio: boolean;
  muteVideo: boolean;
  screenshare: boolean;
  participants: Participant[];
}

const initialState: CallReducer = {
  muteAudio: false,
  muteVideo: false,
  screenshare: false,
  participants: [],
};

type CallAction =
  | Types.QBAction
  | Types.ConferencingClientEvent
  | Types.LogoutSuccessAction;

export default (state = initialState, action: CallAction): CallReducer => {
  switch (action.type) {
    case Types.PARTICIPANT_JOINED:
      return state.participants.find((p) => p.id === action.payload.id)
        ? state
        : {
            ...state,
            participants: state.participants.concat({
              display: action.payload.display,
              id: action.payload.id,
              publisher: true,
              talking: action.payload.talking,
            }),
          };
    case Types.PARTICIPANT_LEFT:
      return {
        ...state,
        participants: state.participants.filter(
          (p) => p.id !== action.payload.userId
        ),
      };
    case Types.LIST_PARTICIPANTS_SUCCESS:
      return { ...state, participants: action.payload };
    case Types.TOGGLE_MUTE_AUDIO_SUCCESS:
      return { ...state, muteAudio: action.payload.muted };
    case Types.TOGGLE_MUTE_VIDEO_SUCCESS:
      return { ...state, muteVideo: action.payload.muted };
    case Types.TOGGLE_SCREENSHARE_SUCCESS:
      return { ...state, screenshare: action.payload.enabled };
    case Types.QB_DISPOSE_SUCCESS:
    case Types.LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};
